@if (warningTransformationLogItem?.warningCode === 'FRE_REDUZIERUNG_NON_PRESENT') {
  <span>
    In der Spalte <i>{{formatArray(warningTransformationLogItem.columnNames)}}</i> wurde kein Wert angegeben. Es wird daher angenommen, dass keine Leistungsreduzierung vorliegt.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'ANLAGENTYP_DOESNT_MATCH_INSTALLIERTE_LEISTUNG') {
  <span>
    Die installierte Leistung und der Anlagentyp Primärenergieträger passen nicht zueinander. PVk-Anlagen dürfen <i>maximal</i> 99 kW besitzen und PV-Anlagen <i>minimal</i> 100 kW.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'ANLAGENTYP_DOESNT_MATCH_ENERGIEART_FRE') {
  <span>
    Die Energieart des FRE und der Anlagentyp Primärenergieträger passen nicht zueinander. Bitte passen Sie einen der Werte an.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'REGELSTUFEN_100_IS_EMPTY') {
  <span>
    In der Spalte <i>{{formatArray(warningTransformationLogItem.columnNames)}}</i> wurde kein Wert oder der falsche Wert angegeben. Daher wird dieses Feld mit "100,100" gefüllt, da nur dieser in diesem Fall gültig ist.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'REGELSTUFEN_70_IS_EMPTY') {
  <span>
    In der Spalte <i>{{formatArray(warningTransformationLogItem.columnNames)}}</i> wurde kein Wert oder der falsche Wert angegeben. Daher wird dieses Feld mit "70,70" gefüllt, da nur dieser in diesem Fall gültig ist.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'IGNORE_RD_RELEVANT_COLUMN_IF_RD_RELEVANT_INDICATOR_IS_FALSE') {
  <span>
    In der Spalte <i>{{formatArray(warningTransformationLogItem.columnNames)}}</i> ist Nein angegeben. Es wurden redispatch - relevante Informationen gefunden, jedoch wurde der Datensatz als nicht redispatch - relevant gekennzeichnet. Mit "Import starten" werden diese redispatch - relevanten Informationen ignoriert und nicht importiert.
  </span>
}

@if (warningTransformationLogItem?.warningCode === 'PLANWERTE_WILL_BE_SET_TO_INVALID') {
  <span>
    Für die Erzeugungsanlage
    @if (warningTransformationLogItem.objects[0] > 1) {
      werden {{warningTransformationLogItem.objects[0]}} Planwerte
    } @else {
      wird {{warningTransformationLogItem.objects[0]}} Planwert
    }
    auf <i>{{PlanwertStatus.INVALID | planwertStatus }}</i> gesetzt. Die Ursache sind Änderungen an den Istdaten der Erzeugungsanlage im Nachgang zur Planwerterfassung.
  </span>
}
